import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import { attr, type SafeHtml } from 'kerfjs';

export const DELETE_ORGANIZATION_DIALOG_ACTIONS = {
  dialog: attr('data-action', 'delete-org-dialog'),
  cancel: attr('data-action', 'delete-org-cancel'),
  confirm: attr('data-action', 'delete-org-confirm'),
} as const;

/**
 * Confirmation dialog for deleting the organization: explains what is removed and
 * requires the organization name to be typed before "Delete permanently" proceeds.
 * Rendered open by its owner (the Data & privacy card's Danger Zone).
 */
export function DeleteOrganizationDialog({ orgName }: { orgName: string }): SafeHtml {
  return (
    <DialogSurface
      label="Delete Organization"
      lightDismiss
      className="delete-organization-dialog"
      rootAttributes={{ 'data-action': DELETE_ORGANIZATION_DIALOG_ACTIONS.dialog.value, 'data-auto-open-dialog': '' }}
      footer={
        <>
          <Button
            emphasis="plain"
            action={DELETE_ORGANIZATION_DIALOG_ACTIONS.cancel.value}
            rootAttributes={{ 'data-dialog-close': '' }}
          >
            Cancel
          </Button>
          <Button tone="danger" emphasis="primary" action={DELETE_ORGANIZATION_DIALOG_ACTIONS.confirm.value}>
            Delete Permanently
          </Button>
        </>
      }
    >
      <List gap="m">
        <ListInsetControl sides="rl">
          <Text>
            This permanently removes <strong>{orgName}</strong> and all its demands, quotations, and analyses. Deletion
            completes within 30 days including backups.
          </Text>
        </ListInsetControl>
        <List>
          <ListInsetControl sides="rl">
            <Text size="compact">
              Type the organization name (<strong>{orgName}</strong>) to confirm.
            </Text>
          </ListInsetControl>
          <ListInsetControl>
            <TextField type="text" ariaLabel="Confirm Organization Name" name="delete-confirm" placeholder={orgName} />
          </ListInsetControl>
        </List>
      </List>
    </DialogSurface>
  );
}
